export type AiSearchRequest = {
  controller: AbortController;
  id: number;
};

let nextRequestId = 0;
let pendingRequest: AiSearchRequest | null = null;

export function beginAiSearchRequest(): AiSearchRequest {
  cancelPendingAiSearch();

  const request = {
    controller: new AbortController(),
    id: ++nextRequestId,
  };
  pendingRequest = request;
  return request;
}

export function cancelPendingAiSearch() {
  pendingRequest?.controller.abort();
  pendingRequest = null;
}

export function isCurrentAiSearchRequest(request: AiSearchRequest) {
  return (
    pendingRequest?.id === request.id && !request.controller.signal.aborted
  );
}

export function finishAiSearchRequest(request: AiSearchRequest) {
  if (pendingRequest?.id === request.id) {
    pendingRequest = null;
  }
}

export function hasPendingAiSearchRequest() {
  return pendingRequest !== null;
}
